define('home/views/ExploreChannelGroupsView',[
    'underscore',

    'core/UniqueModel',

    'home/models/ChannelGroupProfile',
    'home/models/Channel',

    'home/views/common/TabbedView',
    'home/views/FetchingView',
    'home/views/ChannelGroupFeedsView',
    'home/views/ChannelGroupTabCollectionView',

    'home/templates/exploreChannelGroups',
], function (
    _,

    UniqueModel,

    ChannelGroupProfile,
    Channel,

    TabbedView,
    FetchingView,
    ChannelGroupFeedsView,
    ChannelGroupTabCollectionView,

    exploreChannelGroupsTemplate
) {
    'use strict';

    /**
     * View shows a list of channel groups, and the channel feeds available
     * for each channel group.
     *
     * Expects a collection of Channels
     */
    var ExploreChannelGroupsView = TabbedView.extend({
        defaultTab: 'all',

        template: exploreChannelGroupsTemplate,

        regions: _.defaults({
            channelGroupsRegion: '[data-role=channel-groups]',
        }, TabbedView.prototype.regions),

        collectionEvents: {
            sync: 'render',
        },

        initialize: function (options) {
            options = options || {};
            TabbedView.prototype.initialize.call(this, options);
            this.channelFeed = options.channelFeed;
            this.channelTabs = options.channelTabs;
            this.exploreTab = options.exploreTab;
        },

        onDomRefresh: function () {
            TabbedView.prototype.onDomRefresh.call(this);

            this.channelGroupsRegion.show(new ChannelGroupTabCollectionView({
                collection: this.collection,
                exploreTab: this.exploreTab,
                activeTab: this.activeTab,
            }));

            this.updateTabClasses();
        },

        onRender: function () {
            this.updateTabClasses();
        },

        getChannelGroupProfile: function (channel) {
            var channelGroupProfile = new UniqueModel(
                ChannelGroupProfile,
                {
                    id: channel.id,
                    channel: channel,
                }
            );
            channelGroupProfile.ensureFetchedChannel();

            return channelGroupProfile;
        },

        getTabView: function (activeTab) {
            if (!this.collection.length)
                return new FetchingView();

            var viewOptions = {
                activeTab: this.channelFeed,
                exploreTab: this.exploreTab,
                channelGroupTab: activeTab,
                tabs: this.channelTabs,
            };

            if (activeTab === 'all') {
                // The 'all' tab shows content across all channel groups, not any specific
                // channel group. Certain sub feeds under 'all' show content from the
                // spotlight channel, which is curated by hand to contain content from many
                // other channel groups. Other sub feeds under 'all' show content specifically
                // designed for 'all', and stored in a special 'all' ChannelGroupProfile.
                // Pass both the spotlight and the special 'all' ChannelGroupProfiles to the
                // subview.
                var spotlight = new UniqueModel(Channel, { slug: 'spotlight' });
                var spotlightProfile = this.getChannelGroupProfile(spotlight);

                var allChannelGroupsProfile = new UniqueModel(
                    ChannelGroupProfile,
                    {
                        id: ChannelGroupProfile.ALL_CHANNEL_GROUPS_PROFILE_ID,
                    }
                );

                viewOptions.model = spotlightProfile;
                viewOptions.allChannelGroupsProfile = allChannelGroupsProfile;
            } else {
                // The chosen tab shows content only for the selected channel. Pass the
                // ChannelGroupProfile model for that channel to the subview.
                var channel = this.collection.findWhere({ slug: activeTab });

                if (!channel)
                    return null;

                viewOptions.model = this.getChannelGroupProfile(channel);
            }

            return new ChannelGroupFeedsView(viewOptions);
        },
    });

    return ExploreChannelGroupsView;
});

